/**
 * Resolves the org's Reply-To email from the org account attributes. Port of dashboard-v2
 * `app/utils/org-reply-to-email.ts`.
 *
 * The backend returns `notifications_reply_to_email` (already falling back to the legacy value).
 * Before that backend ships, only `notifications_from_email` exists: it held the Reply-To field's value.
 * `notifications_from_email` is never edited here, so the dashboard cannot change the From address.
 *
 * @param {{notifications_reply_to_email?: unknown, notifications_from_email?: unknown} | null | undefined} attributes
 * @returns {string}
 */
export function resolveOrgReplyToEmail(attributes) {
  const replyTo = attributes?.notifications_reply_to_email;
  if (typeof replyTo === "string") {
    return replyTo;
  }

  const legacy = attributes?.notifications_from_email;
  return typeof legacy === "string" ? legacy : "";
}
